// @ts-nocheck
import { sha512 } from 'js-sha512';
import { DocumentsAxiosInstance } from '../axios/axios';
import { isStringValidJson } from 'src/utils/CommonUtils';

export const getAccessToken = () => {
  const sessionStorageKeys = Object.keys(sessionStorage);
  let accessToken = '';
  for (const key of sessionStorageKeys) {
    const obj = sessionStorage.getItem(key);
    if (obj && isStringValidJson(obj)) {
      const item = JSON.parse(obj);
      if (item?.access_token) {
        accessToken = item.access_token;
        break;
      }
    }
  }
  return accessToken;
};

export const webSocketClientWindowKey = 'WebSocketClient';
export const WebSocketReadyStates = {
  Connecting: 'Connecting',
  Open: 'Open',
  Closed: 'Closed',
};

export const WebSocketClient = (window[webSocketClientWindowKey] = window[webSocketClientWindowKey] || {
  webSocket: null,
  connectionId: '',
  connectionState: WebSocketReadyStates.Closed,
  connectionPreparationPromise: null,
  subscribers: [],

  async connect() {
    if (this.connectionState === WebSocketReadyStates.Open) {
      return;
    }

    if (this.connectionState === WebSocketReadyStates.Closed) {
      this.connectionPreparationPromise = this.prepareConnection();
      this.connectionState = WebSocketReadyStates.Connecting;
    }

    if (this.connectionState === WebSocketReadyStates.Connecting) {
      try {
        await this.connectionPreparationPromise;
        this.connectionState = WebSocketReadyStates.Open;
      } catch (error) {
        this.connectionState = WebSocketReadyStates.Closed;
        throw error;
      } finally {
        this.connectionPreparationPromise = null;
      }
    }
  },

  async prepareConnection() {
    const websocketUrl = window.FN_CONFIG.WEBSOCKET_URL;
    const notificationApiUrl = window.FN_CONFIG.NOTIFICATION_API_URL;
    await DocumentsAxiosInstance.post(`${notificationApiUrl}/connections`, null, { withCredentials: true });
    this.webSocket = new window.WebSocket(websocketUrl);
    this.connectionId = `connection_${Date.now().toString(36) + Math.random().toString(36).slice(2, 11)}`;
    this.webSocket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      this.subscribers.forEach((subscriber) => subscriber(message));
    };

    this.webSocket.onclose = () => {
      this.connectionState = WebSocketReadyStates.Closed;
      this.webSocket = null;
      this.tearDownIntervalPing();
    };

    await new Promise((resolve, reject) => {
      this.webSocket.onopen = () => {
        this.connectionState = WebSocketReadyStates.Open;
        this.setupIntervalPing();
        resolve(true);
      };

      this.webSocket.onerror = (errorEvent) => {
        this.connectionState = WebSocketReadyStates.Closed;
        reject(errorEvent);
        this.tearDownIntervalPing();
      };
    });
  },

  async send(data) {
    await this.connect();
    const message = JSON.stringify(data);
    this.webSocket.send(message);
  },

  subscribe(subscriber) {
    this.subscribers.push(subscriber);
    return () => {
      this.subscribers = this.subscribers.filter((currentSubscriber) => currentSubscriber !== subscriber);
    };
  },

  async ping() {
    const message = {
      topic: 'Ping',
      service: 'Notification',
      action: 'Ping',
      accessToken: getAccessToken(),
      uniqueHandler: sha512('Ping'),
    };
    await this.send(message);
  },

  intervalPingId: null,

  setupIntervalPing() {
    this.intervalPingId = setInterval(() => {
      this.ping();
      // every 5 mins
    }, 5 * 60 * 1000);
  },

  tearDownIntervalPing() {
    if (this.intervalPingId) {
      this.clearInterval(this.intervalPingId);
      this.intervalPingId = null;
    }
  },
});
